import { useState } from "react";
import { useToast } from "../../context/ToastContext";
import axios from "axios";

export default function FindImage() {
    
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const { addToast } = useToast();
  
    async function findBestImageForPost(postTitle) {
        try {
          const response = await axios.post('https://aai.bigg.co.uk/webhook/find-image', {
            postTitle
          });
          
          // Parse the nested JSON string from the response
          const resultContent = JSON.parse(response.data.message.content);
          return resultContent;
        } catch (error) {
          console.error('Error finding best image:', error);
          throw error;
        }
      }

    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      
      try {
        const data = await findBestImageForPost(title);
        setResult(data);
        addToast('Successfully found image', 'success');
      } catch (error) {
        console.error('Error:', error);
        addToast('Failed to find image', 'error');
      } finally {
        setLoading(false);
      }
    };
  
    return (
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-semibold mb-6">Find Best Image</h1>
        
        <div className="bg-dark-200 rounded-lg border border-divider p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="title" className="block text-sm font-medium mb-2">
                Post Title
              </label>
              <input
                id="title"
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full px-4 py-2 bg-dark-300 border border-divider rounded-lg focus:outline-none focus:border-accent-primary"
                placeholder="Enter post title"
                required
              />
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-accent-primary text-white rounded-lg hover:bg-accent-primary/90 transition-colors disabled:opacity-50"
            >
              {loading ? 'Finding...' : 'Find Image'}
            </button>
          </form>
  
          {/* Results Section */}
          {result && (
            <div className="mt-8 space-y-6">
              <h2 className="text-lg font-medium mb-4">Results</h2>
              
              <div className="bg-dark-300 rounded-lg overflow-hidden">
                <div className="aspect-video relative">
                  <img
                    src={result.image_url}
                    alt="AI selected image"
                    className="w-full h-full object-cover"
                  />
                </div>
                
                <div className="p-4 space-y-4">
                  <div className="flex items-center gap-2">
                    <span className="text-lg font-semibold">
                      Score: {result.score}/10
                    </span>
                    <span className="px-2 py-1 bg-accent-primary/20 text-accent-primary text-sm rounded-full">
                      AI Selected
                    </span>
                  </div>
                  
                  <div className="text-gray-400">
                    <h3 className="text-white text-sm font-medium mb-2">Explanation</h3>
                    <p>{result.explanation}</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }